import { frFR } from "@material-ui/data-grid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import React, {
  Fragment,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  MdDelete,
  MdEdit,
  MdOutlineRemoveRedEye,
  MdPassword,
  MdWarning,
} from "react-icons/md";
import { GrStatusCriticalSmall, GrStatusCritical } from "react-icons/gr";

import { useNavigate } from "react-router-dom";
import {
  findAll,
  deleteOne,
  save,
} from "../../../../../services/User__Service";
import navContext from "../../../../Context/navContext";
import notifyContext from "../../../../Context/notifyContext";
import Loader from "../../../../Loader/Loader";
import BtnAddUser from "../BtnAdduser/BtnAddUser";
import Form from "../Form/Form";
import Modal from "../../../../Modal/Modal";
import { getTokenData } from "../../../../../services/Auth__Service";

const List = ({ setId }) => {
  const [viewUserId, setViewUserId] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [isSend, setIsSend] = useState(false);

  const redirect = useNavigate();

  const handleEdit = React.useCallback(
    (id) => () => {
      setId(id);
      redirect(`/main/users/edit`);
    },
    []
  );

  const handleSetPassword = React.useCallback(
    (id) => () => {
      setId(id);
      redirect(`/main/users/resetpassword`);
    },
    []
  );

  const handleStatus = React.useCallback(
    (user) => () => {
      setCurrentUser(user);
    },
    []
  );

  const handleDelete = React.useCallback(
    (id) => () => {
      setIdDelete(id);
    },
    []
  );

  const handleSubmitStatus = () => {
    setIsSend(true);
    save({
      ...currentUser,
      statut: currentUser.statut == 0 ? 1 : 0,
      login: currentUser.compte.login,
    })
      .then(() => {
        fetchAllUser();
        notify("Modifié avec succès", "success");
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsSend(false);
        setCurrentUser(null);
      });
  };

  const columns = useMemo(
    () => [
      {
        field: "Image",
        headerName: "",
        valueGetter: (params) => {
          return params.row.chemin ? params.row.chemin : null;
        },
        cellClassName: "img-data-grid",
        renderCell: (params) =>
          params.value && (
            <img className="img-data-grid" src={params.value} alt="" />
          ),
      },
      {
        field: "Nom d'utilisateur",
        headerName: "Nom d'utilisateur",
        flex: 1,
        minWidth: 150,
        valueGetter: (params) => {
          return `${params.row.compte.login}`;
        },
      },
      {
        field: "Client",
        headerName: "Client",
        minWidth: 150,
        valueGetter: (params) => {
          return `${params.row.client ? params.row.client.nom : ""}`;
        },
        flex: 1,
      },
      {
        field: "profil",
        headerName: "Profil",
        type: "singleSelect",
        valueOptions: ["Admin", "Gestionnaire", "Salarié"],
        minWidth: 150,
        valueGetter: (params) => {
          let result = "";
          switch (parseInt(params.row.compte.profil)) {
            case 1:
              result = "Gestionnaire";
              break;
            case 2:
              result = "Salarié";
              break;
            case 3:
              result = "Admin";
              break;
            default:
              break;
          }
          return result;
        },
      },

      {
        field: "statut",
        headerName: "Statut",
        type: "boolean",
        width: 100,
        valueGetter: (params) => {
          return parseInt(params.row.statut) === 1;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        type: "actions",
        width: 100,
        getActions: (params) => [
          <GridActionsCellItem
            icon={<MdOutlineRemoveRedEye />}
            label="Voir"
            onClick={() => setViewUserId(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdEdit />}
            label="Modifier"
            onClick={handleEdit(params.id)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={
              parseInt(params.row.statut) === 0 ? (
                <GrStatusCriticalSmall />
              ) : (
                <GrStatusCritical />
              )
            }
            label={parseInt(params.row.statut) === 0 ? "Activer" : "Désactiver"}
            onClick={handleStatus(params.row)}
            showInMenu
          />,
          <GridActionsCellItem
            icon={<MdPassword />}
            label="Réinitialiser le mot de passe"
            onClick={handleSetPassword(params.id)}
            showInMenu
          />,

          <GridActionsCellItem
            icon={<MdDelete />}
            label="Supprimer"
            onClick={handleDelete(params.id)}
            showInMenu
          />,
        ],
      },
    ],
    [handleDelete, handleEdit, handleSetPassword]
  );

  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [idDelete, setIdDelete] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const nav = useContext(navContext);
  const notify = useContext(notifyContext);

  const handleSubmitDelete = () => {
    deleteOneUser(idDelete);
    setIdDelete(0);
    setIsDeleteLoading(true);
  };

  useEffect(() => {
    nav({
      links: [
        {
          href: "/main/users",
          linkname: "Utilisateurs",
        },
      ],
      children: <BtnAddUser />,
    });
    fetchAllUser();
  }, []);

  const fetchAllUser = async () => {
    findAll()
      .then((response) => {
        setUsers(
          response.data.filter((elt) => {
            return elt.compte.login !== getTokenData().login;
          })
        );
      })
      .catch((error) => {
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const deleteOneUser = async (id) => {
    deleteOne(id)
      .then(() => {
        setIsDeleteLoading(false);
        setIsLoading(true);
        setUsers([]);
        fetchAllUser();
        notify("Supprimé avec succès", "success");
      })
      .catch((error) => {
        setIsDeleteLoading(false);
        if (error.response.data.message !== undefined) {
          notify(error.response.data.message, "error");
        } else {
          notify("Problème au niveau du serveur", "error");
        }
      });
  };

  const handleChangeRowsPerPage = (numberRow) => {
    setRowsPerPage(parseInt(numberRow, 10));
  };

  return (
    <Fragment>
      <div className="user__items">
        <div style={{ height: "100%", width: "100%", background: "#fff" }}>
          <DataGrid
            rows={users}
            columns={columns}
            pageSize={rowsPerPage}
            rowsPerPageOptions={[10, 25, 50, 100]}
            loading={isLoading}
            onPageSizeChange={handleChangeRowsPerPage}
            localeText={frFR.props.MuiDataGrid.localeText}
          />
        </div>
      </div>
      {isDeleteLoading && <Loader loadingMsg="Suppression en cours" />}
      {idDelete !== 0 && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>Êtes-vous sûr (e) de vouloir supprimer cet utilisateur ?</p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                Attention !!! Toutes les données de cet utilisateur seront
                perdues ainsi que toutes les actions effectuées.
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitDelete}>
                Oui
              </button>
              <button className="btn" onClick={() => setIdDelete(0)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}

      {viewUserId !== 0 && (
        <Modal>
          <div className={`modal ${viewUserId !== 0 && "show"} `}>
            <div className="modal__content">
              <div className="modal__header">
                <h2 className="modal__title">Détails Utilisateur</h2>
                <button
                  className="btn modal__close"
                  onClick={() => setViewUserId(0)}
                >
                  X
                </button>
              </div>
              <div className="modal__body">
                <Form id={viewUserId} view={true} />
              </div>
              <div className="modal__footer">
                <button className="btn" onClick={() => setViewUserId(0)}>
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}

      {isSend && <Loader loadingMsg="En cours d'envoi" />}
      {currentUser && (
        <div className="deleteModal">
          <div className="deleteModal__content">
            <div className="deleteModal__question">
              <p>
                {" "}
                {currentUser.statut == 0
                  ? "Êtes-vous sûr (e) de vouloir activer le compte ?"
                  : "Êtes-vous sûr (e) de vouloir désactiver le compte ?"}
              </p>
              <p style={{ color: "red" }}>
                <MdWarning size="25px" />
                {currentUser.statut == 0
                  ? "Attention !!! Cet utlisateur pourra à nouveau se connecter sur la plateforme. "
                  : "Attention !!! Cet utlisateur ne pourra plus se connecter sur la plateforme."}
                <br /> <br />
              </p>
            </div>
            <div className="deleteModal__reponse">
              <button className="btn btn--outline" onClick={handleSubmitStatus}>
                Oui
              </button>
              <button className="btn" onClick={() => setCurrentUser(null)}>
                Non
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default List;
